import { h } from 'vue'
import { RouterView } from 'vue-router'

export default [
  {
    path: '/:lang/membership', // 支持语言前缀
    component: { render: () => h(RouterView) },
    meta: {
      defaultName: 'MemberShip',
      name: 'home.header.Member.name',
      weight: 1,
    },
    children: [
      // 以下是会员名录
      // {
      //   name: 'membershipAll',
      //   path: 'introduction',
      //   meta: {
      //     name: 'home.header.Member.MembershipIntroduction',
      //     pageCode: 'ERA.UC.MEMBERSHIP.MI',
      //   },
      //   component: () => import('@/pages/membership/introduction.vue'),
      // },
      {
        path: '/:lang/membership/list', // 相对路径
        name: 'membershipList',
        meta: {
          defaultName: 'Company Directory',
          name: 'home.header.CompanyDirectory',
          pageCode: 'ERA.UC.MEMBERSHIP',
        },
        component: () => import('@/pages/membership/baseList.vue'),
      },
      {
        path: '/:lang/membership/list/:advantageType-:memberType', // 相对路径
        name: 'membershipListAd',
        meta: {
          headerStyle: 'normal',
          pageCode: 'ERA.UC.MEMBERSHIP.ADVAN',
        },
        component: () => import('~/pages/membership/list.vue'),
      },
      {
        path: '/:lang/membership/listc/:countryName/:advantageType-:memberType', // 相对路径
        name: 'membershipListC',
        meta: {
          headerStyle: 'normal',
          pageCode: 'ERA.UC.MEMBERSHIP.COUNTRY',
        },
        component: () => import('~/pages/membership/list.vue'),
      },
      {
        path: '/:lang/membership/listp/:portName/:advantageType-:memberType', // 相对路径
        name: 'membershipListP',
        meta: {
          headerStyle: 'normal',
          pageCode: 'ERA.UC.MEMBERSHIP.PORT',
        },
        component: () => import('~/pages/membership/list.vue'),
      },

      {
        name: 'membershipJCTransBenefitsOverview',
        path: 'benefits',
        meta: {
          name: 'home.header.Member.BenefitsOverview',
          pageCode: 'ERA.UC.MEMBERSHIP.BO',
        },
        component: () => import('@/pages/membership/benefits.vue'),
      },
    ],
  },
  // 以下是风控相关
  {
    name: 'CooperativeGuarantee',
    path: '/:lang/membership/tools',
    component: { render: () => h(RouterView) },
    meta: {
      name: 'header.cooperativeGuarantee.cooperative_guarantee',
      icon: 'NavMemberTools',
      weight: 5,
      defaultName: 'CooperativeGuarantee',
    },
    redirect: { name: 'membershipToolsRisk' },
    children: [
      // // 黑名单页面 也就是主站的首页 风控首页 H5 里面没有
      // {
      //   path: '/:lang/membership/tools/risk',
      //   name: 'membershipToolsRisk',
      //   meta: {
      //     name: 'home.header.Member.BlackList',
      //     headerStyle: 'normal', // header 样式
      //     pageCode: 'ERA.UC.TOOLS.RISK',
      //   },
      //   component: () => import('@/pages/BlackNew/index.vue'),
      // },

      // 风控 - black名单列表页 risk member list
      {
        path: '/:lang/membership/tools/risk/blackList',
        name: 'membershipToolsBlackList',
        component: () => import('@/pages/BlackNew/BlackList.vue'),
        meta: {
          headerStyle: 'normal', // header 样式
          pageCode: 'ERA.UC.TOOLS.BLACK.BLACKLIST',
        },
      },
      // 风控 - suspend 名单列表页
      {
        path: '/:lang/membership/tools/risk/blackList',
        name: 'membershipToolsSuspendList',
        component: () => import('@/pages/BlackNew/SuspendList.vue'),
        meta: {
          headerStyle: 'normal', // header 样式
          pageCode: 'ERA.UC.TOOLS.BLACK.SUSPENDLIST',
        },
      },
      // 黑名单公司详情页
      {
        path: '/:lang/membership/tools/black/:compId',
        name: 'membershipToolsBlackDetail',
        component: () => import('@/pages/BlackNew/Black/detail.vue'),
        meta: {
          middleware: ['scroll-top'],
          headerStyle: 'normal', // header 样式
          pageCode: 'ERA.UC.TOOLS.BLACK.DETAIL',
        },
      },

      // 保障介绍 规则说明 Assurance
      {
        path: '/:lang/membership/tools/assurance/process',
        name: 'assuranceIntroductionProcess',
        component: () =>
          import('@/pages/BlackNew/Assurance/riskAssuranceProcess.vue'),
        meta: {
          headerStyle: 'normal', // header 样式
          pageCode: 'ERA.UC.TOOLS.RiskAssurance.ProcessIntroduction',
        },
      },
      {
        path: '/:lang/membership/tools/risk/assuranceIntroductionProcess/detail/:id',
        name: 'membershipToolsRiskProcessDetail',
        component: () =>
          import('@/pages/BlackNew/Assurance/AssuranceProcessDetail.vue'),
        meta: {
          headerStyle: 'normal', // header 样式
          pageCode: 'ERA.UC.TOOLS.RISK.PROCESS.DETAIL',
        },
      },
      // 保障介绍 问题 回答
      {
        path: '/:lang/membership/tools/assurance/question',
        name: 'assuranceIntroductionQuestion',
        component: () =>
          import('@/pages/BlackNew/Assurance/riskAssuranceQuestion.vue'),
        meta: {
          headerStyle: 'normal', // header 样式
          pageCode: 'ERA.UC.TOOLS.RiskAssurance.Question',
        },
      },
      // 保障介绍 热点
      {
        path: '/:lang/membership/tools/assurance/topics',
        name: 'assuranceIntroductionTopic',
        component: () =>
          import('@/pages/BlackNew/Assurance/riskAssuranceTopic.vue'),
        meta: {
          headerStyle: 'normal', // header 样式
          pageCode: 'ERA.UC.TOOLS.RiskAssurance.HotTopics',
        },
      },
      // 保障介绍 赔付标准
      {
        path: '/:lang/membership/tools/compensation/standards',
        name: 'compensationStandards',
        component: () => import('@/pages/BlackNew/Assurance/riskStandards.vue'),
        meta: {
          headerStyle: 'normal', // header 样式
          pageCode: 'ERA.UC.TOOLS.RiskAssurance.ProcessIntroduction',
        },
      },

      // 风险防范  案例解析 Prevention
      {
        path: '/:lang/membership/tools/riskPrevention/case',
        name: 'riskPreventionRiskCase',
        component: () => import('@/pages/BlackNew/Prevention/riskCase.vue'),
        meta: {
          headerStyle: 'normal', // header 样式
          pageCode: 'ERA.UC.TOOLS.RiskPrevention.RiskCase',
        },
      },

      // 风险防范  案例解析详情页
      {
        path: '/:lang/membership/tools/risk/detail/:id',
        name: 'riskPreventionRiskCaseDetail',
        component: () => import('@/pages/BlackNew/Prevention/CaseDetail.vue'),
        meta: {
          headerStyle: 'normal', // header 样式
          pageCode: 'ERA.UC.TOOLS.RiskPrevention.CaseDetail',
        },
      },

      // 风险防范  风险分享 Prevention
      {
        path: '/:lang/membership/tools/riskPrevention/sharing',
        name: 'riskPreventionRiskSharing',
        component: () => import('@/pages/BlackNew/Prevention/riskSharing.vue'),
        meta: {
          headerStyle: 'normal', // header 样式
          pageCode: 'ERA.UC.TOOLS.RiskPrevention.RiskSharing',
        },
      },
      // 风险防范  风险分享详情页
      {
        path: '/:lang/membership/tools/risk/video/detail/:id',
        name: 'riskPreventionRiskSharingDetail',
        component: () =>
          import('@/pages/BlackNew/Prevention/SharingDetail.vue'),
        meta: {
          headerStyle: 'normal', // header 样式
          pageCode: 'ERA.UC.TOOLS.RiskPrevention.RiskSharingDetail',
        },
      },

      // 风险防范  风险通知 Prevention
      {
        path: '/:lang/membership/tools/riskPrevention/notice',
        name: 'riskPreventionRiskNotice',
        component: () => import('@/pages/BlackNew/Prevention/riskNotice.vue'),
        meta: {
          headerStyle: 'normal', // header 样式
          pageCode: 'ERA.UC.TOOLS.RiskPrevention.RiskNotice',
        },
      },
      // 风险防范  风险通知详情页
      {
        path: '/:lang/membership/tools/risk/detail/:id',
        name: 'riskPreventionRiskNoticeDetail',
        component: () => import('@/pages/BlackNew/Prevention/NoticeDetail.vue'),
        meta: {
          headerStyle: 'normal', // header 样式
          pageCode: 'ERA.UC.TOOLS.RiskPrevention.RiskNoticeDetail',
        },
      },
    ],
  },

  // 以下是八个会员介绍页
  {
    path: '/:lang/membership/general',
    component: { render: () => h(RouterView) },
    meta: {
      defaultName: 'MemberShipGeneral',
      name: 'home.header.Member.GeneralMembership',
      weight: 1,
    },
    children: [
      {
        name: 'membershipJCTransElite',
        path: 'elite',
        meta: {
          name: 'home.header.Member.JCElite',
          pageCode: 'ERA.UC.MEMBERSHIP.JCE',
          headerIsWhite: true,
          applyMember: true,
        },
        component: () => import('@/pages/membership/general/elite.vue'),
      },
      {
        name: 'membershipJCTransPremium',
        path: 'premium',
        meta: {
          name: 'home.header.Member.JCPremium',
          pageCode: 'ERA.UC.MEMBERSHIP.JCP',
          headerIsWhite: true,
          applyMember: true,
        },
        component: () => import('@/pages/membership/general/premium.vue'),
      },
      {
        name: 'membershipJCTransRising',
        path: 'rising',
        meta: {
          name: 'home.header.Member.JCRising',
          pageCode: 'ERA.UC.MEMBERSHIP.JCRI',
          headerIsWhite: true,
          applyMember: true,
        },
        component: () => import('@/pages/membership/general/rising.vue'),
      },
    ],
  },

  {
    path: '/:lang/membership/specialty',
    name: 'membershipSpecialtyMemberships',
    component: { render: () => h(RouterView) },
    meta: {
      name: 'home.header.Member.SpecialtyMemberships',
    },
    children: [
      {
        name: 'membershipJCTransProjectsAbout',
        path: 'projects',
        meta: {
          name: 'home.header.Member.JCProject',
          pageCode: 'ERA.UC.MEMBERSHIP.JCTP',
          headerIsWhite: true,
          applyMember: true,
        },
        component: () => import('@/pages/membership/specialty/projects.vue'),
      },
      {
        name: 'membershipJCTransDangerousGoodsAbout',
        path: 'dangerous',
        meta: {
          name: 'home.header.Member.JCDangerousGoods',
          pageCode: 'ERA.UC.MEMBERSHIP.JCTD',
          headerIsWhite: true,
          applyMember: true,
        },
        component: () => import('@/pages/membership/specialty/dangerous.vue'),
      },
      {
        name: 'membershipJCTransECommerceAbout',
        path: 'commerce',
        meta: {
          name: 'home.header.Member.JCeCommerce',
          pageCode: 'ERA.UC.MEMBERSHIP.JCEC',
          headerIsWhite: true,
          applyMember: true,
        },
        component: () => import('@/pages/membership/specialty/commerce.vue'),
      },
      {
        name: 'membershipJCTransRailwayAbout',
        path: 'railway',
        meta: {
          name: 'home.header.Member.JCRailway',
          pageCode: 'ERA.UC.MEMBERSHIP.JCR',
          headerIsWhite: true,
          applyMember: true,
        },
        component: () => import('@/pages/membership/specialty/railway.vue'),
      },
    ],
  },
  {
    name: 'membershipSupplierMemberships',
    path: '/:lang/membership/supplier',
    component: { render: () => h(RouterView) },
    meta: {
      name: 'home.header.Member.SupplierMemberships',
      icon: 'NavMemberSupplier',
    },
    children: [
      {
        name: 'membershipJCTransVendor',
        path: 'vendor',
        meta: {
          name: 'home.header.Member.JCVendor',
          oldname: 'JC Vendor',
          pageCode: 'ERA.UC.MEMBERSHIP.JCV',
          headerIsWhite: true,
          applyMember: true,
        },
        component: () => import('@/pages/membership/supplier/vendor.vue'),
      },
    ],
  },
]
